import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

export const fadeInScroll = () => {
  document.addEventListener(
    'DOMContentLoaded',
    () => {

      AOS.init({
        duration: 300,
        // once: true,
        offset: 50,
        easing: 'ease-out',
      });

    }
  );
}


